import { Rule } from '@webkit/index';

export const routingNumber = (customError?: string): Rule<string> => ({
    id: 'routingNumber',
    validator: value => {
        if (!value) return true;

        // Remove all non-numeric characters
        const numeric = value.toString().replace(/[^0-9]/g, '');

        // All routing numbers must be 9 digits
        if (numeric.length !== 9) return false;

        // The sum of the digits must be divisible by 10
        let sum = 0;
        for (let i = 0; i < numeric.length; i += 3) {
            sum +=
                parseInt(numeric.charAt(i), 10) * 3 +
                parseInt(numeric.charAt(i + 1), 10) * 7 +
                parseInt(numeric.charAt(i + 2), 10);
        }

        return sum !== 0 && sum % 10 === 0;
    },
    error: (value?: string) => {
        if (customError) return customError;
        if (!value) return 'Enter routing number';

        const numeric = value.toString().replace(/[^0-9]/g, '');

        if (numeric.length !== 9) {
            return 'Must be 9 digits';
        }

        let sum = 0;
        for (let i = 0; i < numeric.length; i += 3) {
            sum +=
                parseInt(numeric.charAt(i), 10) * 3 +
                parseInt(numeric.charAt(i + 1), 10) * 7 +
                parseInt(numeric.charAt(i + 2), 10);
        }

        if (sum === 0 || sum % 10 !== 0) {
            return 'Checksum is invalid';
        }

        return 'Invalid routing number';
    },
});
